export default __webpack_public_path__ + "static/media/copperExamples.843d0e88.png";